'use client';

import { resolveSegmentArray } from '@macaron-a2ui/core/v0_8';
import { MACARON } from './tokens';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

function segmentColor(style: string): string {
  switch (style) {
    case 'secondary':
      return MACARON.labelSecondary;
    case 'tertiary':
      return MACARON.labelTertiary;
    case 'highlight':
      return MACARON.selectionActive;
    default:
      return MACARON.label;
  }
}

export function MacaronTagText({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const segments = resolveSegmentArray(config.segments, ctx.data);
  if (segments.length === 0) return null;
  return (
    <span className="inline-flex items-center gap-[4px] whitespace-nowrap font-sans text-[12px] font-normal leading-[1.5]">
      {segments.flatMap((seg, i) => [
        ...(i > 0
          ? [
              <span key={`${seg.text}-${i}-separator`} aria-hidden="true" style={{ color: MACARON.labelSecondary }}>
                ·
              </span>,
            ]
          : []),
        <span key={`${seg.text}-${i}`} style={{ color: segmentColor(seg.style) }}>
          {seg.text}
        </span>,
      ])}
    </span>
  );
}
